import React from 'react';

import { SessionStore } from '../../stores/SessionStore';
import { AddressForm } from '../address-form/AddressForm';
import { AddressFormV2 } from '../address-form-v2/AddressFormV2';

const components = {
  'address-form': AddressForm,
};

const componentsV2 = {
  'address-form': AddressFormV2,
};

export const isV2ActiveFor = feature => (SessionStore.user.id && localStorage.getItem(feature) &&
  localStorage.getItem(feature).split(',').includes(SessionStore.user.id.toString()));

const FeatureV2Selector = (props) => {
  // eslint-disable-next-line react/prop-types
  const Component = isV2ActiveFor(props.feature) ?
    // eslint-disable-next-line react/prop-types
    componentsV2[props.component] : components[props.component];
  return <Component {...props} />;
};

export default FeatureV2Selector;



// WEBPACK FOOTER //
// ./src/common/feature-v2-selector/FeatureV2Selector.jsx